<eca-monotron></eca-monotron>

<eca-monotron-body>
  <h1 class="eca-skip-link-focus-target" tabindex="-1">Local Scanning</h1>
  <eca-nav></eca-nav>
  <div class="eca-monotron-description-wrapper">
    <p class="eca-monotron-description">
      Please carefully review each document’s biographic data to ensure it has been correctly input by the user.
      If the biographic data is valid, submit the document to scoring.
    </p>
  </div>

  <div class="filter-bar"
    [formGroup]="form">

    <div class="filter-group">
      <mat-form-field>
        <eca-search matInput
          placeholder="Search"
          formControlName="search"
          [disableAutocomplete]=true>
        </eca-search>
      </mat-form-field>
    </div>

    <div class="button-group">
      <button mat-button
        class="scan-button"
        color="primary"
        [disabled]="!selected.length"
        ecaThrottleClick
        (throttleClick)="submitToScoring()">
        Submit To Scoring
      </button>
    </div>
  </div>

  @if (filteredPending$ | async; as filteredData) {
    <eca-bio-table #bioTable [biographics]="filteredPending$ | async"
      (selected)="onSelection($event)">
    </eca-bio-table>
    <eca-no-results
      [hidden]="filteredData.length !== 0">
    </eca-no-results>
  }

</eca-monotron-body>
